import { toastUtility } from '@/utils/toastUtility';

/**
 * Hook to access the toast service
 * Provides convenience methods for showing toast notifications
 *
 * @example
 * const toast = useToast();
 * toast.showSuccess('Operation completed', 'Your changes have been saved');
 * toast.showError('Error occurred', error.message);
 */
export const useToast = () => {
  return toastUtility;
};
